import React from 'react';
import '../styles/ServiciosList.css';


const getIconForService = (serviceName) => {
  const name = serviceName.toLowerCase();
  
  if (name.includes('avitualla')) return 'fa-water';
  if (name.includes('almacen')) return 'fa-warehouse';
  if (name.includes('amarre')) return 'fa-anchor';
  if (name.includes('carga') || name.includes('descarga')) return 'fa-truck-loading';
  if (name.includes('enlonado')) return 'fa-box-open';
  if (name.includes('pilotaje')) return 'fa-ship';
  if (name.includes('maniobra')) return 'fa-people-carry';
  if (name.includes('remolque')) return 'fa-life-ring';
  
  return 'fa-cog'; 
};

export default function ServiciosList({ services }) {
  if (!services || services.length === 0) {
    return (
      <div className="servicios-card">
        <h3 className="servicios-card-title">Servicios</h3>
        <p>No hay servicios registrados para este puerto.</p>
      </div>
    );
  }

  return (
    <div className="servicios-card">
      <h3 className="servicios-card-title">Servicios</h3>
      <ul className="servicios-list-grid">
        {services.map(serviceName => (
          <li key={serviceName}>
            <i className={`fas ${getIconForService(serviceName)} servicio-icon`}></i>
            <span>{serviceName}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}